import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiAndroid,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiJavascript1,
} from "react-icons/di";
import {
  SiDocker,
  SiFirebase,
  SiJetpackcompose,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandKotlin, TbJetpack } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandKotlin />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiAndroid />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJetpackcompose />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbJetpack />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
    </Row>
  );
}

export default Techstack;
